import React, { useState } from "react";
import { Button, Container, Form, Row, Col } from "react-bootstrap";
import { ToastContainer, toast } from "react-toastify";
import "./UnifiedFormStyles.css";
import AppButton from "../../Components/MerchantButton";
import bir from "../../Assets/Logo/BIR.png";
import { validateMerchantDetails } from "../../Helpers/Validation/FormValidationVer2";
import { getByProcastCode } from "../../Helpers/API/formsAPI";

function MerchantDetails({ navigation, primaryDetails, setPrimaryDetails }) {
  const [isError, setIsError] = useState({
    procast_code: false,
    company_name: false,
    store_name: false,
    trade_name: false,
  });

  // // Region options
  // const REGION_OPTIONS = [
  //   "North Luzon",
  //   "North NCR",
  //   "Rizal NCR",
  //   "South NCR",
  //   "South Luzon",
  //   "Visayas",
  //   "Mindanao",
  // ];

  const handleInputChange = (e) => {
    const { name } = e.target;
    let { value } = e.target;
    // Only remove spaces for procast_code
    if (name === "procast_code") {
      value = value.replace(/\s+/g, "");
    }
    setPrimaryDetails(prev => ({ ...prev,
      [name]: value,
    }));

    // Clear error when user starts typing
    if (isError[name]) {
      setIsError({
        ...isError,
        [name]: false,
      });
    }
  };

  const isFormValid = () => {
    return !!primaryDetails.procast_code &&
      !!primaryDetails.company_name &&
      !!primaryDetails.store_name &&
      !!primaryDetails.trade_name;
  };
  const handleProcastCodeBlur = async () => {
    if (!primaryDetails.procast_code || primaryDetails.procast_code.trim() === "") {
      return;
    }

    try {
      const response = await getByProcastCode(primaryDetails.procast_code);
      
      if (response.data && response.data.success === true) {
        setPrimaryDetails({
          ...primaryDetails,
          ...response.data.data
        });
        toast.success("Merchant details auto-filled successfully!");
      }
    } catch (error) {
      console.error("Error fetching procast code:", error);
    }
  };

  const validateForm = () => {
    return validateMerchantDetails(primaryDetails, setIsError);
  };

  const handleSubmit = () => {
    if (validateForm()) {
      navigation.go("region-form");
    } else {
      toast.error("Please fill in all required fields", {
        autoClose: 3000,
        hideProgressBar: true,
        theme: "colored",
      });
    }
  };

  const handleBack = () => {
     navigation.previous();
  };

  return (
    <div className="form-bg">
      <Container>
        <ToastContainer />
        <Row className="justify-content-md-center">
          <Col md={10}>
            <div className="form-main-header">
              <h4 className="form-title">MERCHANT DETAILS</h4>
              <p className="form-desc">
                Please provide the merchant information below
              </p>
            </div>
            <div className="form-main">
              <div className="form-main-content">
                <Form>
                  {/* Procast Code */}
                  <Form.Group className="mb-5" controlId="procast_code">
                    <Form.Label className="form-label">
                      Procast Code <span className="form-required">*</span>
                    </Form.Label>
                    <Form.Control
                      type="text"
                      name="procast_code"
                      value={primaryDetails.procast_code || ""}
                      onChange={handleInputChange}
                      onBlur={handleProcastCodeBlur}
                      placeholder="Enter Procast Code"
                      className={`form-input${
                        isError.procast_code ? " form-input-error" : ""
                      }`}
                    />
                    {isError.procast_code && (
                      <div className="form-error">This field is required</div>
                    )}
                    <div>
                        <p className="form-note-text">
                          <em>"Note: Type the complete Procast Code. Make sure there are no spaces in between."</em>
                        </p>
                      </div>
                  </Form.Group>

                  {/* BRN/Company Name - Static Image */}
                  <Form.Group className="mb-5" controlId="brn_company_image">
                    <Form.Label className="form-label">
                      Merchant/Company Name <span className="form-required">*</span>
                    </Form.Label>
                    <div className="form-image-display">
                      <img
                        src={bir} 
                        alt="BRN/Company Name Document"
                        className="form-image"
                      />
                    </div>
                    {/* BRN/Company Name Text Field */}
                    <div className="form-file-desc-field">
                      <Form.Control
                        type="text"
                        name="company_name"
                        value={primaryDetails.company_name || ""}
                        onChange={handleInputChange}
                        placeholder="Input Company Name"
                        className="form-input"
                      />
                    </div>
                    {isError.company_name && (
                      <div className="form-error">
                        Please provide BRN/Company Name description
                      </div>
                    )}
                  </Form.Group>

                  {/* LIF/DBA/Store Name */}
                  <Form.Group className="mb-5" controlId="store_name">
                    <Form.Label className="form-label">
                      LIF (DBA,CITY,OUTLET) <span className="form-required">*</span>
                    </Form.Label>
                    <Form.Control
                      type="text"
                      name="store_name"
                      value={primaryDetails.store_name || ""}
                      onChange={handleInputChange}
                      placeholder="Enter store name"
                      className={`form-input${
                        isError.store_name ? " form-input-error" : ""
                      }`}
                    />
                    {isError.store_name && (
                      <div className="form-error">This field is required</div>
                    )}
                     <div>
                        <p className="form-note-text">
                          <em>"Note: Kopyahin ng kumpleto ang nakalagay na LIF sa resibo."</em>
                        </p>
                      </div>
                  </Form.Group>
                  
                  {/* TRADE NAME (DBA) */}
                  <Form.Group className="mb-5" controlId="trade_name">
                    <Form.Label className="form-label">
                      TRADE NAME (Doing Business As) <span className="form-required">*</span>
                    </Form.Label>
                    <Form.Control
                      type="text"
                      name="trade_name"
                      value={primaryDetails.trade_name || ""}
                      onChange={handleInputChange}
                      placeholder="Enter trade name"
                      className={`form-input${
                        isError.trade_name ? " form-input-error" : ""
                      }`}
                    />
                    {isError.trade_name && (
                      <div className="form-error">This field is required</div>
                    )}
                  </Form.Group>
                  {/* Region */}
                  {/* <Form.Group className="mb-5" controlId="region">
                    <Form.Label className="form-label">
                      Region <span className="form-required">*</span>
                    </Form.Label>
                    <div className="form-radio-group">
                      {REGION_OPTIONS.map((region, index) => (
                        <div
                          key={`region-${index}-${region}`}
                          className={`form-radio-item${
                            primaryDetails.region === region ? " selected" : ""
                          }`}
                        >
                          <div className="form-radio-flex">
                            <Form.Check
                              type="radio"
                              id={`region-${index}`}
                              name="region"
                              value={region}
                              label={region}
                              checked={primaryDetails.region === region}
                              onChange={handleInputChange}
                              className="form-radio"
                            />
                          </div>
                        </div>
                      ))}
                    </div>
                    {isError.region && (
                      <div className="form-error">Please select a region</div>
                    )}
                  </Form.Group> */}

                  {/* Navigation Buttons */}
                  <div className="form-nav-btns">
                    <AppButton
                      onClick={handleBack}
                      variant="back"
                      className="form-btn variant-secondary"
                    >
                      ← Back
                    </AppButton>
                    <AppButton
                      onClick={handleSubmit}
                      variant="next"
                      className="form-btn variant-primary"
                      disabled={!isFormValid()}
                    >
                     Next →
                    </AppButton>
                  </div>
                </Form>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default MerchantDetails;
